import { render, staticRenderFns } from "./MonitoringPointSelector.vue?vue&type=template&id=572a3376&scoped=true&"
import script from "./MonitoringPointSelector.vue?vue&type=script&lang=js&"
export * from "./MonitoringPointSelector.vue?vue&type=script&lang=js&"
import style0 from "./MonitoringPointSelector.vue?vue&type=style&index=0&id=572a3376&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "572a3376",
  null
  
)

/* custom blocks */
import block0 from "./MonitoringPointSelector.vue?vue&type=custom&index=0&blockType=i18n&lang=yaml"
if (typeof block0 === 'function') block0(component)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/project/client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('572a3376')) {
      api.createRecord('572a3376', component.options)
    } else {
      api.reload('572a3376', component.options)
    }
    module.hot.accept("./MonitoringPointSelector.vue?vue&type=template&id=572a3376&scoped=true&", function () {
      api.rerender('572a3376', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/molecules/MonitoringPointSelector.vue"
export default component.exports